// frontend/src/components/SupplierCategorySuggestion.jsx
// Roadmap 3.6 — línea compacta con la fuente de la categoría propuesta para
// un proveedor (patrón visual 3.4, como ClassifySuggestion): determinista
// (history/token → icono History) o IA (Sparkles + razón + confianza %).
// Solo informa: la confirmación humana sigue siendo guardar la factura.
import { History, Sparkles } from "lucide-react";
import { proposalSourceLabel } from "@/utils/supplierCategories";

export default function SupplierCategorySuggestion({ proposal }) {
  const info = proposalSourceLabel(proposal);
  if (!info) return null;
  const isAi = info.kind === "ai";
  const Icon = isAi ? Sparkles : History;
  return (
    <div
      className="mt-1.5 flex items-center gap-1.5 text-xs text-violet-800 bg-violet-50 border border-violet-200 rounded px-2 py-1.5 min-w-0"
      data-testid="supplier-category-suggestion"
    >
      <Icon className="w-3.5 h-3.5 shrink-0" />
      {isAi && <span className="font-medium shrink-0">Sugerencia IA:</span>}
      <span className="flex-1 min-w-0 truncate" title={proposal?.reason || undefined}>
        {info.label}
      </span>
    </div>
  );
}
